export const ROUTES = {
  ONBOARDING: 'Onboarding',
  WELCOME: '/signin',
  OTP_VERIFICATION: '/verification',
  NOT_ALLOWED: '/not-allowed',
  OAUTH_CALLBACK: '/auth/callback/:provider',
  SETTINGS: '/settings',
  SETTINGS_MAGIC_LINK: '/settings/magic-link',
  SETTINGS_WORKSPACES: '/settings/workspaces',
  SETTINGS_CONTACT_UPLOAD: '/settings/contact-upload',
  SETTINGS_ORGANIZATIONAL_STRUCTURE: '/settings/organizational-structure',
  SETTINGS_UPLOAD_SHIFTS: '/settings/upload-shifts',
  SETTINGS_QUALITY_METRICS: '/settings/quality-metrics',
  RESTRICTED: '/restricted',

  ROOT: '/',
  PDF_VIEWER: 'Pdf Viewer',
  NOTIFICATION_MODAL: 'Notification Modal',
  HOME: '/',
  CONTENT_ITEM: '/knowledge/:id',
  ITEMS: 'Knowledge items',

  CHECKLISTS: 'Checklists',
  LABS: '/compendium',
  LABS_CATEGORIES: '/compendium/:id',

  ADMISSION: '/admission',
  ADMISSION_CATEGORIES: '/admission/:id',

  FAVORITES: '/favorites',
  SEARCH: '/search',

  USER_PROFILE_POPUP: '/profile-popup',
  USER_PROFILE: '/profile',
  SELECT_ORGANIZATION: '/select-organization',
  OWNERS_MANAGEMENT: '/owners',
  USERS_MANAGEMENT: '/users',
  MY_CONTENT: '/my-content',
  COMMUNICATION_CENTER: '/communication',
  COMMUNICATION_ITEM: '/communication/:id',
  KNOWLEDGE: '/knowledge',
  KNOWLEDGE_ITEMS: '/knowledge/items/:id',
  KNOWLEDGE_CATEGORIES: '/knowledge/:id',
  KNOWLEDGE_ITEMS_NEW: '/knowledge/items/new',
  KNOWLEDGE_ITEMS_EDIT: '/knowledge/items/:id/edit',

  ROTATIONS: '/rotations',
  CONTACTS: '/contacts',
  CONTACTS_PREVIEW: '/contacts/:id',
  CONTACTS_EDIT: '/contacts/:id/edit',
  SUGGEST_CONTENT: '/suggest-content',
  KNOWLEDGE_HUB: '/hub',
  KNOWLEDGE_HUB_ITEMS: '/hub/items/:id',
  KNOWLEDGE_HUB_SEARCH: '/hub/search',
  QUALITY_METRIC: '/quality-metric',
  QUALITY_METRIC_CASES: '/quality-metric/cases/:id',
  EDUCATIONAL_EVENTS: '/events',
  EDUCATIONAL_EVENT_CHECK_IN: '/events/:id/check-in',
  EDUCATIONAL_EVENT_CHECK_IN_SUFFIX: '/check-in',
  CHANGELOG: '/changelog',
};

export const INTERNAL_ROUTING = {
  QUERY_PARAMS: {
    KNOWLEDGE: 'category',
    ATTACHMENT: 'attachment',
    CHECKLIST: 'checklist',
    COMPENDIUM: 'values',
    CONTACTS: 'id',
    USERS: 'id',
    USERS_AFFECTED_FIELD: 'affectedField',
    USERS_AFFECTED_OPTION: 'affectedOption',
    USERS_AFFECTED_SCOPE: 'affectedScope',
    ROTATIONS: 'id',
    ROTATIONS_FILTER: 'filter',
    ROTATIONS_TAB: 'tab',
    HUB: 'hub-category',
    HUB_ORGANIZATION: 'oid',
    HUB_WORKSPACE: 'wid',
    HUB_CATEGORY: 'cid',
    HUB_SEARCH: 'q',
    RESTRICTED_ID: 'id',
    RESTRICTED_ENTITY: 'entity',
    SEARCH_TERM: 'term',
    SEARCH_TYPE: 'type',
    QUALITY_METRIC_TAB: 'tab',
    CHECK_IN_CODE: 'code',
  },
};
